import { useCallback, useMemo } from 'react';
import { mapClientPermissionToResellerRole } from 'src/constants/constants';
import {
  expandRolePermissionKeys,
  hasExplicitPermission,
  toPermissionKeySet,
} from 'src/mindtime/utils/permissionKeys';
import useAuth from './useAuth';

const useHasPermissions = () => {
  const { user } = useAuth();
  const permissionKeys = useMemo(
    () => expandRolePermissionKeys(user?.permissions),
    [user?.permissions],
  );

  return useCallback(
    (requiredPermissions: string[]): boolean =>
      requiredPermissions.every((permission) => {
        const normalized = String(permission ?? '').trim().toLowerCase();
        if (hasExplicitPermission(permissionKeys, normalized)) return true;
        const resellerForm = mapClientPermissionToResellerRole(normalized);
        if (hasExplicitPermission(permissionKeys, resellerForm)) return true;
        const rawKeys = toPermissionKeySet(user?.permissions);
        return hasExplicitPermission(rawKeys, normalized) || hasExplicitPermission(rawKeys, resellerForm);
      }),
    [permissionKeys, user?.permissions],
  );
};

export default useHasPermissions;
